import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getStockList({
    cursor = '',
    limit = '',
    product_id = '',
    q = '',
    warehouse_id = '',
  } = {}) {
    const params = {
      cursor,
      limit,
      product_id,
      q,
      warehouse_id,
    };
    return api.get('/stocks', { params: omitBy(params, isNil) });
  },
  getStockReport() {
    return api.get('/stocks/stock_reports');
  },
  getProductStock(productId) {
    return api.get(`/stocks/products/${productId}`);
  },
  updateStock(id, payload) {
    return api.put(`/stocks/${id}`, payload);
  },
  bulkUpdateStock(payload) {
    return api.post('/stocks/bulk_update', payload);
  },
  createStock(payload) {
    return api.post('/stocks', payload);
  },
};
